import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import DriverDashboard from './DriverDashboard';
import JobDetail from './JobDetail';

const { FiGrid, FiList, FiUser, FiLogOut } = FiIcons;

function DriverNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useAuth();

  const items = [
    { path: '/driver', icon: FiGrid, label: 'Dashboard' },
    { path: '/driver/jobs', icon: FiList, label: 'All Jobs' },
    { path: '/driver/profile', icon: FiUser, label: 'Profile' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex items-center justify-around px-2 py-2 z-50 shadow-lg">
      {items.map(item => {
        const active = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-0.5 px-4 py-1 rounded-xl transition-colors ${active ? 'text-brand-navy' : 'text-gray-400'}`}
          >
            <item.icon className={`text-2xl ${active ? 'text-brand-gold' : ''}`} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
      <button
        onClick={signOut}
        className="flex flex-col items-center gap-0.5 px-4 py-1 rounded-xl text-red-400"
      >
        <FiLogOut className="text-2xl" />
        <span className="text-[10px] font-medium">Logout</span>
      </button>
    </div>
  );
}

export default function DriverApp() {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <Routes>
        <Route path="/" element={<DriverDashboard />} />
        <Route path="/jobs" element={<DriverDashboard showAll />} />
        <Route path="/job/:id" element={<JobDetail />} />
        <Route path="/profile" element={<DriverProfile />} />
      </Routes>
      <DriverNav />
    </div>
  );
}

function DriverProfile() {
  const { profile, user, signOut } = useAuth();
  return (
    <div className="p-4 pt-8">
      <h1 className="text-2xl font-bold text-brand-navy mb-6">My Profile</h1>
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center mb-6">
        <div className="h-20 w-20 bg-brand-navy text-brand-gold rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-3">
          {profile?.full_name?.charAt(0) || 'D'}
        </div>
        <h2 className="text-xl font-bold text-brand-navy">{profile?.full_name}</h2>
        <p className="text-gray-500 text-sm">{user?.email}</p>
        <span className="inline-block mt-2 bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full">Driver</span>
      </div>
      <button
        onClick={signOut}
        className="w-full py-3 rounded-xl border-2 border-red-200 text-red-500 font-semibold hover:bg-red-50 transition-colors"
      >
        Sign Out
      </button>
    </div>
  );
}